import { useContext } from 'react';
import type { Me } from '@/api/me';
import { MeContext } from './meContextValue';

export function useMe(): Me {
  const value = useContext(MeContext);
  if (!value) throw new Error('useMe() must be used inside <MeProvider>.');
  return value.me;
}

/** `null` outside `MeProvider` — stand-alone screens hide the account menu. */
export function useOptionalMe(): Me | null {
  const value = useContext(MeContext);
  return value?.me ?? null;
}

/** Re-issues `GET /v1/me`; returns the fresh profile, or no value if the last session was retained. */
export function useMeRefetch(): () => Promise<Me | void> {
  const value = useContext(MeContext);
  if (!value) throw new Error('useMeRefetch() must be used inside <MeProvider>.');
  return value.refetch;
}
